// extracted by mini-css-extract-plugin
export default {"button":"button--xnFRi button","group":"group--a54zU"};